import { useContext } from 'react'
import { Client, Session } from '../contexts/parameters'
import I18n from '../locales/I18n'

export const useRiseUpClient: () => {
  isRiseup: boolean
  primaryColor: string
  objectiveIdRu: number | null
  objectiveUidRu: string | null
  lang: string
} = () => {
  const client = useContext(Client.State)
  const session = useContext(Session.State)
  const objectiveIdsRu: number[] = session?.options?.analytics?.objective_ids || []
  const objectiveUidsRu: string[] = session?.options?.analytics?.objective_uids || []

  const lang = I18n.locale

  if (!client) {
    throw new Error('useRiseUpClient must be used within an Parameters provider')
  }

  return {
    isRiseup: client.riseup_client,
    primaryColor: client.mqb_primary_color,
    objectiveIdRu: objectiveIdsRu.length > 0 ? Number(objectiveIdsRu[0]) : null,
    objectiveUidRu: objectiveUidsRu.length > 0 ? objectiveUidsRu[0] : null,
    lang: lang || 'fr'
  }
}
